'use client'

import Cookies from 'js-cookie'
import { Check, Globe2 } from 'lucide-react'
import { useRouter } from 'next/navigation'
import React from 'react'

import { STORAGE_LANG_KEY } from '@/constants'
import { useTranslation } from '@/i18n/client'
import { cn } from '@/utils/cn'

const languages = [
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
] as const

export function LanguageSelector() {
  const { i18n } = useTranslation()

  const r = useRouter()

  const [isOpen, setIsOpen] = React.useState(false)
  const currentLanguage =
    languages.find((l) => l.code === i18n.resolvedLanguage) ?? languages[0]

  return (
    <div className='relative'>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className='flex items-center gap-2 text-gray-400 transition-colors hover:text-gray-300'
        onBlur={() => setTimeout(() => setIsOpen(false), 200)}
      >
        <Globe2 className='h-5 w-5' />
        <span>{currentLanguage.label}</span>
      </button>

      {isOpen && (
        <div className='absolute bottom-full right-0 mb-2 w-48 overflow-hidden rounded-lg border border-gray-700 bg-gray-800 shadow-lg animate-in fade-in-50 slide-in-from-bottom-2'>
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={cn(
                'flex w-full items-center justify-between px-4 py-2 text-left',
                'transition-colors hover:bg-gray-700/50',
                lang.code === currentLanguage.code
                  ? 'text-blue-400'
                  : 'text-gray-300'
              )}
              onClick={() => {
                Cookies.set(STORAGE_LANG_KEY, lang.code)
                setIsOpen(false)
                i18n.changeLanguage(lang.code)
                r.refresh()
              }}
            >
              {lang.label}
              {lang.code === currentLanguage.code && (
                <Check className='h-4 w-4' />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
